import { useEffect, useRef, useState } from 'react';

import useDisclosure from '@/core/hooks/useDisclosure';
import useOnClickOutside from '@/core/hooks/useOnClickOutside';

export type SelectOption = { title: string; hash: string };

type UseAutoCompleteInputProps = { selectOptions: SelectOption[] | undefined; searchValue: string };
export const useAutoCompleteInput = ({ selectOptions, searchValue }: UseAutoCompleteInputProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const containerRef = useRef<HTMLDivElement>(null);

  const [selectOptionsFiltered, setOptionsFiltered] = useState<SelectOption[]>([]);

  useEffect(() => {
    // filter options by search value
    if (selectOptions) {
      const searchRegex = new RegExp(searchValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
      const selectOptionsFiltered = selectOptions.filter(({ title }) => title.match(searchRegex));
      if (selectOptionsFiltered) {
        setOptionsFiltered(selectOptionsFiltered);
        return;
      }
      setOptionsFiltered([]);
    }
  }, [searchValue, selectOptions]);

  useOnClickOutside([containerRef], () => {
    onClose();
  });

  return {
    isOpen,
    selectOptionsFiltered,
    onOpen,
    onClose,
    containerRef,
  };
};
